import { IoIosStar, IoIosStarOutline } from "react-icons/io"
import methodModel from "../../methods/methods"
import moment from "moment"
import { useSelector } from "react-redux"
import { useRef, useState } from "react"
import ApiClient from "../../methods/api/apiClient"
import loader from "../../methods/loader"
import { BiDotsVerticalRounded } from "react-icons/bi"
import { FaTrash } from "react-icons/fa6"
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { MdEdit } from "react-icons/md"

const Rating = ({ reviews, getReviews, userId, role }) => {
    const user = useSelector((state) => state.user)
    const [hoverRating, setHoverRating] = useState(0);
    const [form, setForm] = useState({ rating: "", review: "", ratingId: "" })
    const [submited, setSubmited] = useState(false)
    const reviewRef = useRef()

    const handleSubmit = (e) => {
        e.preventDefault()
        setSubmited(true)
        if (!form?.rating) return
        const payload = {
            ...form,
            addedTo: userId,
            addedToType: role,
            addedBy: user?._id || user?.id,
            type: form?.ratingId ? "update" : "give"
        }
        if (!form?.ratingId) delete payload?.ratingId
        loader(true)
        ApiClient.post(`ratings/give/update`, payload).then(res => {
            if (res.success) {
                getReviews()
                setSubmited(false)
                setForm({ rating: "", review: "", ratingId: "" })
            }
            loader(false)
        })
    }

    const editReview = (item) => {
        setForm({ rating: item?.rating, review: item?.review, ratingId: item?._id || item?.id })
        setTimeout(() => {
            reviewRef.current.focus();
            reviewRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 0);
    }

    const deleteReview = (item) => {
        loader(true)
        ApiClient.delete(`ratings/delete?ratingId=${item?._id || item?.id}`).then(res => {
            if (res.success) {
                getReviews()
            }
            loader(false)
        })
    }

    const findReview=()=>{
        let value = true
        if(reviews?.data?.length > 0){
            value = reviews?.data?.some((item)=>item?.addedByDetails?._id !== user?._id)
        }
        return value
    }

    return (
        <>
            <div className="bg-white border p-5">
                <div className="">
                    <div className='flex flex-wrap justify-between items-center gap-3 mb-5'>
                        <div className="">
                            <h1 className="text-xl lg:text-3xl font-semibold text-gray-800 capitalize">Rate {role === "host" ? "Entertainer" : role}</h1>
                            <p className="text-[15px] text-gray-500">Your feedback helps us improve!</p>
                        </div>
                        <div className="">
                            <h2 className='text-[24px] font-[600] text-center'>{parseFloat(reviews?.overallRating).toFixed(1) || 0}</h2>
                            <div className="flex justify-center gap-1">
                                {[...Array(Number(parseInt(reviews?.overallRating) || 0))].map((itm, i) => (
                                    <IoIosStar key={i} className="text-[15px] text-[#ffb800] cursor-pointer" />
                                ))}
                            </div>
                            <p className='text-sm text-center text-gray-500'>Based on reviews</p>
                        </div>
                    </div>
                    {reviews?.data?.length > 0 &&
                        <div className="pt-5 pb-5">
                            <div className="grid grid-cols-1 gap-5 max-h-[500px] overflow-auto">
                                {reviews?.data?.map((item, index) => {
                                    return <div className='border-t relative pt-5' key={index}>
                                        <div className='flex gap-2 mb-1 px-3'>
                                            <img src={methodModel.userImg(item?.addedByDetails?.image)} className='w-[45px] min-w-[45px] h-[45px] rounded-full object-cover' />
                                            <div className='w-full'>
                                                <div className='min-h-[45px] flex gap-3 items-center justify-between'>
                                                    <div>
                                                        <h2 className='text-[16px] font-[500]'>{item?.addedByDetails?.fullName || item?.addedByDetails?.firstName}</h2>
                                                        <p className='text-[10px] text-gray-500'>{moment(item?.createdAt).fromNow()}</p>
                                                    </div>
                                                    {item?.addedBy === (user?._id || user?.id) ?
                                                        <div className="absolute top-[10px] right-[10px] cursor-pointer rounded-full felx justify-center items-center">
                                                            <Menu>
                                                                <MenuButton>
                                                                    <BiDotsVerticalRounded />
                                                                </MenuButton>
                                                                <MenuItems
                                                                    transition
                                                                    anchor="bottom end"
                                                                    className="w-fit bg-white origin-top-right rounded-md border text-sm/6 transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
                                                                >
                                                                    <MenuItem>
                                                                        <button type="button" onClick={e => editReview(item)} className="group text-[13px] flex w-full items-center gap-2 py-1 px-2 hover:bg-[#f1f1f1]">
                                                                            <MdEdit className="w-[18px] h-[18px] p-[1px] size-4 text-[#828282]" />Edit
                                                                        </button>
                                                                    </MenuItem>
                                                                    <MenuItem>
                                                                        <button type="button" onClick={e => deleteReview(item)} className="group text-[13px] flex w-full items-center gap-2 py-1 px-2 hover:bg-[#f1f1f1]">
                                                                            <FaTrash className="w-[18px] h-[18px] p-[1px] size-4 text-[#828282]" />Delete
                                                                        </button>
                                                                    </MenuItem>
                                                                </MenuItems>
                                                            </Menu>
                                                        </div>
                                                        : null}
                                                    <div className="flex justify-center gap-1">
                                                        {[...Array(Number(item?.rating || 0))].map((itm, i) => (
                                                            <IoIosStar key={i} className="text-[15px] text-[#ffb800] cursor-pointer" />
                                                        ))}
                                                    </div>
                                                </div>
                                                <p className='text-gray-500 text-sm'>{item?.review}</p>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    }
                    {user?.role === "member" && findReview() || form?.ratingId ?
                        <form onSubmit={handleSubmit}>
                            <div className='bg-[#f7f7f7] rounded lg p-5'>
                                <div className="mb-3">
                                    <div className="flex gap-2">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <svg
                                                key={star}
                                                onClick={() => setForm((prev) => ({ ...prev, rating: star }))}
                                                onMouseEnter={() => setHoverRating(star)}
                                                onMouseLeave={() => setHoverRating(0)}
                                                className={`w-10 h-10 cursor-pointer transform transition duration-300 ease-in-out ${hoverRating >= star || form?.rating >= star ? 'text-[#ffb800]' : 'text-[#EFEFEF]'}`}
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                            >
                                                <polygon points="10 15.27 16.18 19 14.54 12.97 20 8.63 13.81 8.63 10 2 6.19 8.63 0 8.63 5.46 12.97 3.82 19" />
                                            </svg>
                                        ))}
                                    </div>
                                    {submited && !form?.rating ? <p className="text-sm text-red-600">Rating is required</p> : null}
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-600">Your Comments:</label>
                                    <textarea ref={reviewRef} value={form?.review} onChange={e => setForm((prev) => ({ ...prev, review: e.target.value }))} rows="4" className="w-full mt-2 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-0" placeholder="Share your thoughts..." required />
                                </div>
                            </div>
                            <div className="text-right mt-5">
                                <button type="submit" className="text-white bg-[#005AAB] font-medium rounded-full text-sm py-2.5 px-5 text-center cursor-pointer hover:opacity-[90%]">
                                    Submit Feedback
                                </button>
                            </div>
                        </form>
                        : null
                    }
                </div>
            </div >
        </>
    )
}

export default Rating